import Menu from './Menu.js';
import '../Style/cover.css';

const Cover = () => {

	return (

		<div id="Cover" className="column-container">

			<Menu/>

			<div className="banner-cover column-container">

				<div className="banner-header column-container">

				<h1 className="center underline"> Jade Conradie </h1>

				</div>

				<h2 className="center underline"> photography </h2>

			</div>
			
		</div>
	
	);

}

export default Cover;